(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clean-product-slider"] && !Shopify.designMode) return;
  try {
    
    // Keep swatch selection independent of older slider initializers.
    (function () {
      if (window.__cleanSwatchesV2) return;
      window.__cleanSwatchesV2 = true;
      document.addEventListener('click', function (e) {
        if (!(e.target instanceof Element)) return;
        var swatch = e.target.closest('.css-swatch');
        if (swatch) {
          e.preventDefault();
          var card = swatch.closest('.css-card');
          var add = card.querySelector('.css-atc');
          if (!add || add.getAttribute('aria-busy') === 'true') return;
          e.stopPropagation();
          card.querySelectorAll('.css-swatch').forEach(function (item) {
            item.setAttribute('aria-pressed', item === swatch ? 'true' : 'false');
          });
          add.setAttribute('data-variant-id', swatch.dataset.id);
          var available = swatch.dataset.available === 'true';
          var arabic = document.documentElement.lang.indexOf('ar') === 0;
          add.disabled = !available;
          add.setAttribute('aria-label', available ? (arabic ? 'أضف إلى السلة' : 'Add to cart') : (arabic ? 'غير متاح' : 'Sold out'));
          add.title = add.getAttribute('aria-label');
          card.querySelector('.css-variant-label').textContent = swatch.dataset.title + (available ? '' : (arabic ? ' — غير متاح' : ' — Sold out'));
          card.querySelector('.css-new-price').textContent = swatch.dataset.price;
          var oldPrice = card.querySelector('.css-old-price');
          oldPrice.textContent = swatch.dataset.compare;
          oldPrice.hidden = !swatch.dataset.compare;
          var badge = card.querySelector('.css-discount');
          badge.textContent = '-' + swatch.dataset.discount + '%';
          badge.hidden = !swatch.dataset.compare;
          var picture = card.querySelector('.css-image-link img');
          if (picture && swatch.dataset.image) {
            picture.srcset = swatch.dataset.srcset;
            picture.src = swatch.dataset.image;
          }
          card.querySelectorAll('.css-image-link, .css-title').forEach(function (link) {
            link.href = swatch.dataset.url;
          });
          return;
        }

      }, true);
    })();

    (function () {
      if (window.__cleanSliderInit) return;
      window.__cleanSliderInit = true;

      var navFrame = 0;
      function updateAll() {
        if (navFrame) return;
        navFrame = requestAnimationFrame(function () {
          navFrame = 0;
          var states = Array.from(document.querySelectorAll('.css-track')).map(function (track) {
            var wrapper = track.closest('.css-slider-wrapper');
            return { wrapper: wrapper, pos: Math.abs(track.scrollLeft), max: track.scrollWidth - track.clientWidth };
          });
          states.forEach(function (state) {
            if (!state.wrapper) return;
            var prev = state.wrapper.querySelector('.css-prev');
            var next = state.wrapper.querySelector('.css-next');
            if (prev) prev.style.display = state.pos <= 5 ? 'none' : 'flex';
            if (next) next.style.display = state.pos >= state.max - 5 ? 'none' : 'flex';
          });
        });
      }
      function updateNav() { updateAll(); }
      document.addEventListener('scroll', function (e) {
        if (e.target.classList && e.target.classList.contains('css-track')) updateAll();
      }, {capture:true, passive:true});

      document.addEventListener('click', function (e) {
        // Slider arrows
        var nav = e.target.closest('.css-nav-btn');
        if (nav) {
          var track = nav.closest('.css-slider-wrapper').querySelector('.css-track');
          var rtl = document.documentElement.dir === 'rtl';
          var dir = parseInt(nav.getAttribute('data-dir'), 10) * (rtl ? -1 : 1);
          track.scrollBy({ left: dir * 300, behavior: 'smooth' });
          return;
        }

        // Add to cart
        var btn = e.target.closest('.css-atc[data-variant-id]');
        if (!btn) return;
        e.preventDefault();
        if (btn.disabled) return;
        btn.disabled = true;

        var root = (window.Shopify && window.Shopify.routes.root) || '/';
        var sections = Array.from(document.querySelectorAll('hdt-cart-drawer, hdt-main-cart'))
          .map(function (cart) { return cart.getAttribute('section-id'); })
          .filter(Boolean);
        sections = Array.from(new Set(sections));
        var added = false;
        var arabic = document.documentElement.lang.indexOf('ar') === 0;
        var payload = {
          items: [{ id: btn.getAttribute('data-variant-id'), quantity: 1 }],
          sections: sections,
          sections_url: window.location.pathname
        };
        btn.setAttribute('aria-busy', 'true');

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(async function (response) {
            var data = await response.json();
            if (!response.ok || data.status) {
              throw new Error(data.description || data.message || (arabic ? 'تعذرت إضافة المنتج.' : 'Unable to add this product.'));
            }
            added = true;
            return data;
          })
          .then(function (data) {
            if (!sections.length) {
              window.location.assign(root + 'cart');
              return;
            }
            if (sections.some(function (id) { return !data.sections || !data.sections[id]; })) {
              throw new Error('Cart section rendering failed.');
            }
            // Kalles uses cart:update with rendered sections, not cart:updated.
            // The native listener updates contents/count and then opens the drawer.
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: {},
                sourceId: btn.getAttribute('data-variant-id'),
                cartData: data,
                actionAfterATC: 'open_cart_drawer',
                source: 'product-form-component',
                data: { itemCount: 1, sections: data.sections }
              }
            }));
          })
          .catch(function (err) {
            console.error('Clean slider cart:', err);
            window.alert(added
              ? (arabic ? 'تمت إضافة المنتج، لكن تعذر تحديث عرض السلة. افتح صفحة السلة لمراجعته؛ لا تضفه مرة أخرى.' : 'Product added, but the cart display could not update. Open the cart page to review it; do not add it again.')
              : err.message);
          })
          .finally(function () {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          });
      });

      window.addEventListener('resize', updateAll);
      document.addEventListener('shopify:section:load', updateAll);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { updateAll(); setTimeout(updateAll, 200); });
      } else {
        updateAll();
        setTimeout(updateAll, 200);
      }
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lux-footer-new"] && !Shopify.designMode) return;
  try {
    
(function () {
  var COLORS = [
    'rgba(255, 182, 193, 0.7)',
    'rgba(255, 160, 180, 0.65)',
    'rgba(255, 192, 210, 0.7)',
    'rgba(250, 150, 175, 0.6)',
    'rgba(255, 210, 225, 0.75)'
  ];

  function startPetals(canvas) {
    var banner = canvas.parentElement;
    var ctx = canvas.getContext('2d');
    var petals = [];
    var count = 18;
    var raf = null, visible = false, initialized = false;
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    function pause() { cancelAnimationFrame(raf); raf = null; }
    function sync() {
      if (!visible || document.hidden || motion.matches || !canvas.isConnected) { pause(); return; }
      if (!initialized) {
        resize();
        for (var i = 0; i < count; i++) petals.push(createPetal(true));
        initialized = true;
      }
      if (raf === null) raf = requestAnimationFrame(animate);
    }
    var visibility = new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; sync(); });
    visibility.observe(banner);
    document.addEventListener('visibilitychange', sync);
    motion.addEventListener('change', sync);

    function resize() {
      var width = banner.offsetWidth, height = banner.offsetHeight;
      canvas.width = width;
      canvas.height = height;
    }

    function createPetal(randomY) {
      return {
        x: Math.random() * canvas.width,
        y: randomY ? Math.random() * canvas.height : -20 - Math.random() * 80,
        size: 6 + Math.random() * 7,
        speedY: 0.4 + Math.random() * 0.5,
        speedX: -0.3 + Math.random() * 0.6,
        rotation: Math.random() * Math.PI * 2,
        rotSpeed: (Math.random() - 0.5) * 0.012,
        color: COLORS[Math.floor(Math.random() * COLORS.length)],
        narrow: Math.random() > 0.5,
        sway: Math.random() * Math.PI * 2,
        swaySpeed: 0.008 + Math.random() * 0.008,
        swayAmount: 0.3 + Math.random() * 0.4
      };
    }

    function animate() {
      raf = null;
      if (!visible || document.hidden || motion.matches || !canvas.isConnected) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (var i = 0; i < petals.length; i++) {
        var p = petals[i];
        p.sway += p.swaySpeed;
        p.x += p.speedX + Math.sin(p.sway) * p.swayAmount;
        p.y += p.speedY;
        p.rotation += p.rotSpeed;
        if (p.y > canvas.height + 20) { p = petals[i] = createPetal(false); }
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.fillStyle = p.color;
        ctx.beginPath();
        ctx.ellipse(0, 0, p.size * (p.narrow ? 0.4 : 0.5), p.size * (p.narrow ? 0.9 : 1), 0, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }
      raf = requestAnimationFrame(animate);
    }

    function onResize() { if (initialized && visible) resize(); }
    window.addEventListener('resize', onResize);

    return function stop() {
      pause();
      visibility.disconnect();
      window.removeEventListener('resize', onResize);
      document.removeEventListener('visibilitychange', sync);
      motion.removeEventListener('change', sync);
    };
  }

  function init(scope) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var canvases = (scope || document).querySelectorAll('[data-lux-petals]');
    for (var i = 0; i < canvases.length; i++) {
      if (!canvases[i]._stopPetals) canvases[i]._stopPetals = startPetals(canvases[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var c = e.target.querySelector('[data-lux-petals]');
    if (c && c._stopPetals) { c._stopPetals(); c._stopPetals = null; }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lux-trust-strip"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MOBILE_QUERY = '(max-width: 900px)';

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  function LuxTrust(root) {
    var self = this;
    this.root = root;
    this.viewport = root.querySelector('.lux-trust-viewport');
    this.track = root.querySelector('.lux-trust-track');
    this.dotsWrap = root.querySelector('.lux-trust-dots');
    this.count = this.track.children.length;

    this.wantSlider = root.getAttribute('data-slider') === 'true';
    this.devices = root.getAttribute('data-slider-devices') || 'mobile';
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.autoplay = root.getAttribute('data-autoplay') === 'true' && !this.reduceMotion;
    this.speed = (parseInt(root.getAttribute('data-speed'), 10) || 4) * 1000;
    this.colsDesktop = parseInt(root.getAttribute('data-cols-desktop'), 10) || 4;
    this.colsMobile = parseInt(root.getAttribute('data-cols-mobile'), 10) || 2;

    this.active = false;
    this.locked = false;
    this.paused = false;
    this.index = 0;
    this.perView = 1;
    this.rtl = false;
    this.timer = null;
    this.fallback = null;
    this.startX = null;
    this.startY = null;

    this.onResize = debounce(function () { self.setup(); }, 150);
    this.onTransitionEnd = function (e) {
      if (e.target === self.track && e.propertyName === 'transform') self.normalize();
    };

    window.addEventListener('resize', this.onResize);
    this.track.addEventListener('transitionend', this.onTransitionEnd);

    root.addEventListener('mouseenter', function () { self.paused = true; });
    root.addEventListener('mouseleave', function () { self.paused = false; });
    root.addEventListener('focusin', function () { self.paused = true; });
    root.addEventListener('focusout', function () { self.paused = false; });

    this.viewport.addEventListener('pointerdown', function (e) {
      self.startX = e.clientX;
      self.startY = e.clientY;
    });
    this.viewport.addEventListener('pointerup', function (e) {
      if (!self.active || self.startX === null) return;
      var dx = e.clientX - self.startX;
      var dy = e.clientY - self.startY;
      self.startX = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      var forward = self.rtl ? dx > 0 : dx < 0;
      self.step(forward ? 1 : -1);
    });

    this.visible = false;
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.onVisibility = function () { self.startAutoplay(); };
    this.visibilityObserver = new IntersectionObserver(function (entries) {
      self.visible = entries[0].isIntersecting;
      self.startAutoplay();
    });
    this.visibilityObserver.observe(root);
    document.addEventListener('visibilitychange', this.onVisibility);
    this.motion.addEventListener('change', this.onVisibility);
    this.setup();
  }

  LuxTrust.prototype.teardown = function () {
    this.stopAutoplay();
    clearTimeout(this.fallback);
    var clones = this.track.querySelectorAll('.is-clone');
    for (var i = 0; i < clones.length; i++) clones[i].parentNode.removeChild(clones[i]);
    this.track.style.transform = '';
    this.track.style.transition = '';
    this.root.classList.remove('is-slider');
    if (this.dotsWrap) this.dotsWrap.innerHTML = '';
    this.active = false;
    this.locked = false;
  };

  LuxTrust.prototype.makeClone = function (node) {
    var clone = node.cloneNode(true);
    clone.classList.add('is-clone');
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('data-shopify-editor-block');
    if (clone.tagName === 'A') clone.tabIndex = -1;
    return clone;
  };

  LuxTrust.prototype.setup = function () {
    this.teardown();

    var mobile = window.matchMedia(MOBILE_QUERY).matches;
    this.perView = mobile ? this.colsMobile : this.colsDesktop;

    var allowed = this.wantSlider && (this.devices === 'all' || mobile);
    if (!allowed || this.count <= this.perView) return;

    var n = this.perView;
    var originals = Array.prototype.slice.call(this.track.children);
    var i;

    this.rtl = window.getComputedStyle(this.root).direction === 'rtl';

    var head = document.createDocumentFragment();
    for (i = this.count - n; i < this.count; i++) head.appendChild(this.makeClone(originals[i]));
    this.track.insertBefore(head, this.track.firstChild);

    for (i = 0; i < n; i++) this.track.appendChild(this.makeClone(originals[i]));

    this.root.style.setProperty('--lt-per-view', n);
    this.root.classList.add('is-slider');
    this.active = true;
    this.index = n;
    this.buildDots();
    this.move(false);
    this.startAutoplay();
  };

  LuxTrust.prototype.move = function (animate) {
    var w = this.viewport.clientWidth / this.perView;
    var dir = this.rtl ? 1 : -1;
    this.track.style.transition = animate ? 'transform 600ms cubic-bezier(.22,.61,.36,1)' : 'none';
    if (!animate) void this.track.offsetWidth;
    this.track.style.transform = 'translate3d(' + (dir * this.index * w) + 'px,0,0)';
    this.updateDots();
  };

  LuxTrust.prototype.step = function (delta) {
    if (!this.active || this.locked) return;
    var self = this;
    this.locked = true;
    this.index += delta;
    this.move(true);
    clearTimeout(this.fallback);
    this.fallback = setTimeout(function () { self.normalize(); }, 750);
  };

  LuxTrust.prototype.normalize = function () {
    if (!this.active || !this.locked) return;
    clearTimeout(this.fallback);
    var n = this.perView;
    var c = this.count;
    var changed = false;
    if (this.index >= n + c) { this.index -= c; changed = true; }
    else if (this.index < n) { this.index += c; changed = true; }
    if (changed) this.move(false);
    this.locked = false;
  };

  LuxTrust.prototype.goTo = function (i) {
    var delta = this.perView + i - this.index;
    if (delta !== 0) this.step(delta);
  };

  LuxTrust.prototype.buildDots = function () {
    if (!this.dotsWrap) return;
    var self = this;
    this.dotsWrap.innerHTML = '';
    for (var i = 0; i < this.count; i++) {
      (function (i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', (i + 1) + ' / ' + self.count);
        b.addEventListener('click', function () {
          self.goTo(i);
          self.stopAutoplay();
          self.startAutoplay();
        });
        self.dotsWrap.appendChild(b);
      })(i);
    }
  };

  LuxTrust.prototype.updateDots = function () {
    if (!this.dotsWrap || !this.dotsWrap.children.length) return;
    var c = this.count;
    var real = (((this.index - this.perView) % c) + c) % c;
    for (var i = 0; i < this.dotsWrap.children.length; i++) {
      this.dotsWrap.children[i].setAttribute('aria-current', i === real ? 'true' : 'false');
    }
  };

  LuxTrust.prototype.startAutoplay = function () {
    var self = this;
    this.stopAutoplay();
    if (!this.autoplay || !this.active || !this.visible || document.hidden || this.motion.matches) return;
    this.timer = setInterval(function () {
      if (!self.paused && !document.hidden) self.step(1);
    }, this.speed);
  };

  LuxTrust.prototype.stopAutoplay = function () {
    clearInterval(this.timer);
    this.timer = null;
  };

  LuxTrust.prototype.destroy = function () {
    this.visibilityObserver.disconnect();
    document.removeEventListener('visibilitychange', this.onVisibility);
    this.motion.removeEventListener('change', this.onVisibility);
    this.teardown();
    window.removeEventListener('resize', this.onResize);
    this.track.removeEventListener('transitionend', this.onTransitionEnd);
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-lux-trust]');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i]._luxTrust) roots[i]._luxTrust = new LuxTrust(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target.querySelector('[data-lux-trust]');
    if (r && r._luxTrust) { r._luxTrust.destroy(); r._luxTrust = null; }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
